import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Faq } from '../../../models/faq.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FaqService } from '../../../services/faq.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FaqCategory } from '../../../models/faqcategory.model';
import { FaqCategoryService } from '../../../services/faqcategory.service';

declare var jQuery: any;
declare var CKEDITOR: any;

@Component({
  selector: 'app-faq-edit',
  templateUrl: './faq-edit.component.html',
  styleUrls: ['./faq-edit.component.css']
})
export class FaqEditComponent implements OnInit, OnDestroy, AfterViewInit {
  id: number;
  loading = false;
  editMode = false;
  backUrl: string;

  subscription: Subscription;
  subscriptionCategory: Subscription;
  subscriptionResponse: Subscription;

  faq: Faq;
  faqscategory: FaqCategory[] = [];
  faqForm: FormGroup;

  constructor(private faqService: FaqService, private route: ActivatedRoute,
    private router: Router, private faqCategoryService: FaqCategoryService) { }

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        this.id = +params['id'];
        this.editMode = params['id'] != null;
        this.backUrl = this.editMode ? '../../' : '../';

        if (this.id) {
          this.loading = true;
          this.faqCategoryService.httpGetFaqsCategory();
          this.faqService.httpGetFaq(this.id);

        }
      }
    );

    this.faqCategoryService.httpGetFaqsCategory();

    this.subscriptionCategory = this.faqCategoryService.faqsCategoryChanged.subscribe(
      (faqscategory: FaqCategory[]) => {
        this.faqscategory = faqscategory;
      }
    );

    this.subscription = this.faqService.faqChanged.subscribe(
      (faq: Faq) => {
        this.faq = faq;

        if ( this.editMode ) {
          this.loading = false;
          this.initFormEdit();
        }
      }
    );

    this.subscriptionResponse = this.faqService.faqOperation.subscribe(
      (faq: Faq) => {
        if ( typeof faq.ID !== 'undefined' ) {
          this.loading = true;
          this.router.navigate([this.backUrl], {relativeTo: this.route});
        }
      }
    );

    this.initForm();
  }

  ngAfterViewInit() {
    // CKEDITOR.config.customConfig = 'configAdmin';
    const toolbar = [
      { name: 'clipboard', items: [ 'Undo', 'Redo', '-' ] },
      { name: 'basicstyles', groups: [ 'basicstyles' ], items: [ 'Bold', 'Italic', 'Underline', '-' ] },
      // tslint:disable-next-line:max-line-length
      { name: 'paragraph', groups: [ 'list', 'align', 'justify' ], items: [ 'NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight'] },
      { name: 'styles', items: [ 'Format', 'Font', 'FontSize' ] },
      { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
      { name: 'links', items : [ 'Link', 'Unlink'] },
      { name: 'insert', items: [ 'Image', 'Table' ] }
    ];
    CKEDITOR.replace('textarea', {
      toolbar: toolbar
    });
  }

  private initForm() {
    this.faqForm = new FormGroup({
      'title': new FormControl('', Validators.required),
      'provider': new FormControl('', Validators.required),
      'category': new FormControl(''),
      'description': new FormControl('')
    });
  }

  private initFormEdit() {

    CKEDITOR.instances.textarea.setData(this.faq.description);

    this.faqForm.patchValue({
    'title': this.faq.title,
    'provider': this.faq.provider,
    'category': this.faq.category,
    'description': this.faq.description
    });
  }

  onSubmit() {
    const faqValues = this.faqForm.value;
    faqValues['description'] = CKEDITOR.instances.textarea.getData();

    this.loading = true;

    if ( this.editMode ) {
      this.faqService.httpPutFaq(this.id, faqValues);
    } else {
      this.faqService.httpPostFaq(faqValues);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionCategory.unsubscribe();
    this.subscriptionResponse.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/help/faq-edit/faq-edit.component.ts